import Header from './Header';
import Mobile from './Mobile';
import Sider from './Sider';

export default {
    Header,
    Mobile,
    Sider,
};
